import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styles from './Campaigns.module.sass';
import CampaignPreview from './campaign_preview/CampaignPreview';
import { userObjectSelector } from '../../../user/selectors/user';
import {
  campaignsByCategorySelector,
} from '../../selectors/campaigns';

function Campaigns(props) {
  const { user, campaignsByCategory } = props;

  useEffect(() => {
    if (user && window.userLoggedInCallback) {
      window.userLoggedInCallback(user);
      window.userLoggedInCallback = null;
    }
  }, [user && user.id]);

  return (
    <div className={styles.campaigns}>
      <div className={styles.content}>
        <div className={styles.title}>
          The Lab |
          {' '}
          <span className={styles.selected}>
            ALL PRODUCTS
          </span>
        </div>
        { campaignsByCategory.map((category) => (
          <div className={styles.block} key={category.category_name}>
            <div className={styles.title}>
              {category.category_name}
            </div>
            <div className={styles.items}>
              { category.campaigns.map((campaign) => (
                <CampaignPreview
                  key={campaign.id}
                  campaign={campaign}
                  className={styles.item}
                />
              ))}
            </div>
          </div>
        )) }
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: userObjectSelector(state),
  campaignsByCategory: campaignsByCategorySelector(state),
});

Campaigns.propTypes = {
  campaignsByCategory: PropTypes.arrayOf(
    PropTypes.shape({
      category_name: PropTypes.string,
      campaigns: PropTypes.arrayOf(PropTypes.shape()),
    }),
  ).isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
};

Campaigns.defaultProps = {
  user: null,
};

export default connect(mapStateToProps)(Campaigns);
